import Dashboard from '@/modules/DashboardCard';
import useUser from '@authentication/hooks/useUser';
import React from 'react';

function DashboardPage() {
  const { pageTitle, setPageTitle } = useUser();

  React.useEffect(() => {
    setPageTitle('');
  }, [pageTitle]);

  return <Dashboard />;
}

export default DashboardPage;
